import React, { useState, useEffect } from "react";
import { GrNotification } from "react-icons/gr";
import { IoIosArrowBack } from "react-icons/io";
import { LuUser, LuLogOut } from "react-icons/lu";
import "./Header.css";
import config from "../../config";

const Header = ({ title, subtitle, onBack, onProfileClick, showBack = false, children, profileImage: profileImageProp }) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [showLogoutPopup, setShowLogoutPopup] = useState(false);
  const [userDetails, setUserDetails] = useState({
    name: "",
    role: "GUEST",
  });
  const [profileImage, setProfileImage] = useState("icons/user.png");

  useEffect(() => {
    const companyName = localStorage.getItem("companyName") || "";
    const role = "Admin";

    setUserDetails({
      name: companyName,
      role,
    });

    const savedImage = localStorage.getItem("profileImage");
    if (savedImage) {
      setProfileImage(savedImage);
    } else {
      setProfileImage("icons/user.png");
    }

    const token = localStorage.getItem("Authorization");
    const email = localStorage.getItem("userEmail");
    const isFetched = sessionStorage.getItem("profileFetched");

    if (token && email && !isFetched) {
      const fetchProfileImage = async () => {
        try {
          const url = `${config.API_BASE_URL}${config.PROFILE_ENDPOINT}?email=${email}`;
          const response = await fetch(url, {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          });

          if (response.ok) {
            const fullResponse = await response.json();
            const resData = fullResponse.body || fullResponse;
            const imageName = resData.image || resData.profileImage || resData.imageUrl;

            if (imageName && imageName !== "icons/user.png") {
              localStorage.setItem("rawProfileImage", imageName);
              const viewUrlResponse = await fetch(
                `${config.API_BASE_URL}${config.VIEW_PRESIGNED_URL_ENDPOINT}?filename=${encodeURIComponent(imageName)}`,
                {
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                }
              );
              if (viewUrlResponse.ok) {
                let viewUrl = await viewUrlResponse.text();
                if (viewUrl.startsWith('"') && viewUrl.endsWith('"')) {
                  viewUrl = JSON.parse(viewUrl);
                }
                setProfileImage(viewUrl);
                localStorage.setItem("profileImage", viewUrl);
              }
            } else {
              setProfileImage("icons/user.png");
              localStorage.removeItem("profileImage");
              localStorage.removeItem("rawProfileImage");
            }
          }
          sessionStorage.setItem("profileFetched", "true");
        } catch (err) {
          console.error("Error fetching profile image in Header:", err);
        }
      };

      fetchProfileImage();
    }
  }, []);

  const handleLogoutClick = () => {
    setShowDropdown(false);
    setShowLogoutPopup(true);
  };

  const handleConfirmLogout = () => {
    localStorage.removeItem("Authorization");
    localStorage.removeItem("firstName");
    localStorage.removeItem("lastName");
    localStorage.removeItem("role");
    localStorage.removeItem("orgId");
    localStorage.removeItem("companyName");
    localStorage.removeItem("profileImage");
    localStorage.removeItem("rawProfileImage");
    sessionStorage.removeItem("profileFetched");
    window.location.href = "/signin";
  };

  const handleCancelLogout = () => {
    setShowLogoutPopup(false);
  };

  return (
    <div className='header'>
      <div className='header-left'>
        {showBack && (
          <button className='back-arrow-btn' onClick={onBack}>
            <IoIosArrowBack />
          </button>
        )}
        {children}
        {(title || subtitle) && (
          <div>
            {title && <h4>{title}</h4>}
            {subtitle && <p>{subtitle}</p>}
          </div>
        )}
      </div>

      <div className='user-profile'>
        <span className='notification-icon'>
          <GrNotification />
        </span>

        <div
          className='profile-click-area'
          onClick={() => setShowDropdown(!showDropdown)}
        >
          <img src={profileImageProp || profileImage} alt='User' className='user-image' />

          <div className='user-info'>
            <span className='user-role'>{userDetails.role}</span>
            <span className='user-name'>{userDetails.name}</span>
          </div>
        </div>

        {showDropdown && (
          <div className='profile-dropdown'>
            <div
              className='dropdown-item'
              onClick={() => {
                setShowDropdown(false);
                if (onProfileClick) onProfileClick();
              }}
              style={{ width: "100%", boxSizing: "border-box" }}
            >
              <LuUser size={18} />
              <span>Profile</span>
            </div>

            <div
              onClick={handleLogoutClick}
              className='dropdown-item logout-btn'
              style={{
                width: "100%",
                boxSizing: "border-box"
              }}
            >
              <LuLogOut size={18} />
              <span>Logout</span>
            </div>
          </div>
        )}
      </div>

      {showLogoutPopup && (
        <div className="logout-popup-overlay">
          <div className="logout-popup-box">
            <div className="logout-icon-container">
              <LuLogOut size={24} />
            </div>
            <div className="logout-popup-title">Sign Out</div>
            <div className="logout-popup-text">Are you sure you want to sign out of your account?</div>
            <div className="logout-popup-actions">
              <button className="logout-cancel-btn" onClick={handleCancelLogout}>Cancel</button>
              <button className="logout-confirm-btn" onClick={handleConfirmLogout}>Sign Out</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Header;
